import React from "react";
import { Route, Switch } from "react-router-dom/cjs/react-router-dom";
import { DocumentTitle } from "../../components/DocumentTitle/DocumentTitle";
import StatisticsContainer from "./StatisticsContainer";

const StatisticsMain = ({ match }) => {
    return (
        <div className="column">
            <DocumentTitle title={"CARMA - Statistics"} />
            <div>
                <Switch>
                    <Route exact path={`${match.path}`} component={StatisticsContainer} />
                </Switch>
            </div>
        </div>
    )
}

export default StatisticsMain